import { useQuery } from '@tanstack/react-query';
import { chatApi } from '@data/rest/api';
import { ChatMessage } from '../chatTypes';

export const chatMessageKeys = Object.freeze({
    all: ['chat_messages'] as const,
    byChat: (chatId: number | null) => [...chatMessageKeys.all, chatId] as const,
});

export function useChatMessages(chatId: number | null, enabled: boolean = true) {
    return useQuery({
        queryKey: chatMessageKeys.byChat(chatId),
        queryFn: async (): Promise<ChatMessage[]> => {
            if (chatId === null) {
                return [];
            }
            return chatApi.getAllByChatId(chatId);
        },
        enabled: enabled && chatId !== null,
        staleTime: 0, // Always refetch when switching chats
    });
}
